import type { PlannedPostRead } from '../../types/api';
import { addDays } from '../calendar/calendarDates';

/** How far ahead "this week" looks: today and the six days after it. */
export const THIS_WEEK_DAYS = 7;

/** Plans from `today` through six days on, in date order. Dates are `YYYY-MM-DD`. */
export function plansThisWeek(plans: readonly PlannedPostRead[], today: string): PlannedPostRead[] {
  const last = addDays(today, THIS_WEEK_DAYS - 1);
  return plans
    .filter((plan) => plan.scheduled_on >= today && plan.scheduled_on <= last)
    .sort((a, b) => a.scheduled_on.localeCompare(b.scheduled_on));
}
